<template>
  <div class="career margin-t-2">
    <div class="dashboard-page-title">
      <div class="container-fluid" ref="width">
        <router-link :to="{ name: 'talent.profile.show', params: { id: this.userId } }" class="btn btn-info">
          <i class="fa fa-chevron-left"></i> Back
        </router-link>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">
        <h2 class="border-none">What are you famous for?</h2>
        <div>
          <div class="spacer-b-2 lead-text">Select roles, past or present, that you are most well known for</div>
          <div class="flex flex-row flex-wrap gray-500 w-2/3 justify-between">
            <div class="info-item"><div class="flex justify-start align-center" style="width: 30px"><i class="fa fa-search"></i></div> Appear in more searches</div>
            <div class="info-item"><div class="flex justify-start align-center" style="width: 30px"><i class="fa fa-line-chart"></i></div> Get more profile views</div>
            <div class="info-item"><div class="flex justify-start align-center" style="width: 30px"><i class="fa fa-user-plus"></i></div> Be recommended for more opportunities</div>
          </div>
        </div>

        <div>
          <div class="spacer-y-1 lead-text">Search by industry, profession, sport or club</div>
          <tag-picker
            input-id="search"
            :current="nodes"
            :full-width="true"
            :with-icon="true"
            :with-popper="true"
            placeholder="Search"
            @selected="handleSearchSelected"
            :default-fetch="true"/>
        </div>

        <div class="bg-white margin-t-3 spacer-x-4 spacer-y-4" v-if="nodes.length || underReview.length">
          <profile-career-tags-list-item v-for="node in nodes" :key="node.id" :node="node" @selected="handleSelected" @delete="handleDetachNode" @toggleRetired="handleToggleRetired" :current="nodes"/>
          <div class="flex flex-col career-list-item" v-for="tag in underReview" :key="tag.id">
            <div class="career-list-item__row flex flex-row justify-between">
              <div class="career-list-item__row--header">
                {{ tag.name }}
              </div>
              <div class="flex flex-row">
                Is this current?
                <toggle-button
                  v-model="tag.current"
                  :sync="true"
                  :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"
                  class="margin-x-2"
                  :labels="{ checked: 'YES', unchecked: 'NO' }"
                  @input="(value) => { handleToggleRetiredPending(tag, value) }"/>
                <div class="delete-button">
                  <i class="fa fa-times" @click="() => { handleDeletePendingTag(tag) }"></i>
                </div>
              </div>
            </div>
            <div class="career-list-item__row career-list-item__row--highlight">
              Under Review
            </div>
          </div>
          <div class="spacer-t-4">
            <span @click="focusSearch" class="cursor-pointer add-button add-button--bold"><i class="fa fa-plus"></i> Add Another</span>
          </div>
        </div>
        <div class="flex justify-center align-center bg-white spacer-y-4 spacer-x-2 margin-t-3" v-else>
          <button class="add-button" @click="focusSearch">Add your first industry</button>to be more recognisable
        </div>
      </div>
    </div>
    <div class="container-fluid footer-container" :class="fixed ? 'fixed' : 'relative'" :style="'max-width: ' + width + 'px;' + 'min-width: ' + width + 'px'">
      <div class="flex footer">
        <div class="hidden-xs">
          Select 1 or more industry tags that apply
        </div>
        <div class="flex flex-row align-center">
          <router-link :to="{ name: 'talent.profile.show', params: { id: this.userId } }" class="btn btn-primary">
            Confirm
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from 'utils'
import { mapState } from 'vuex'
import { OpportunityTracker } from 'mixins/analytics'

import ProfileCareerTagsListItem from './ProfileCareerTagsListItem'
import TagPicker from '../misc/TagPicker'
export default {
  mixins: [OpportunityTracker],
  components: { TagPicker, ProfileCareerTagsListItem },

  data () {
    return {
      fixed: true,
      width: 1200,
      nodes: [],
      underReview: []
    }
  },

  mounted () {
    http.get(`talent-nodes/${this.userId}`).then(response => {
      this.nodes = response.data
    })

    http.get(`talent-nodes/${this.userId}/vetting`).then(response => {
      this.underReview = response.data
    })

    const target = document.getElementById('footer')
    const options = {
      root: null,
      threshold: 0
    }
    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.fixed = false
        } else {
          this.fixed = true
        }
      })
    }
    // eslint-disable-next-line
    const observer = new IntersectionObserver(callback, options)
    observer.observe(target)
    window.addEventListener('resize', this.handleResize)
  },

  updated () {
    this.handleResize()
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize () {
      if (this.$refs.width) {
        this.width = this.$refs.width.clientWidth ? this.$refs.width.clientWidth : 1200
      }
    },

    handleAttachNode (nodeId, nodeName) {
      http.put(`talent-nodes/${this.userId}/${nodeId}/attach`)
      this.trackEvent(this.analytics.V2.AccountTaggingElementAppliedEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.CAREER, tagName: nodeName })
    },

    handleAddCustomNode (node) {
      http.post(`talent-nodes/${this.userId}/create`, { name: node.name }).then(response => {
        const index = this.underReview.findIndex(element => element.id === node.id)
        if (index !== -1) {
          this.underReview.splice(index, 1, response.data)
        }
        this.trackEvent(this.analytics.V2.AccountTaggingElementAppliedEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.CAREER, tagName: node.name })
      })
      this.underReview.push(node)
    },

    handleDetachNode (node) {
      const index = this.nodes.findIndex(element => element.id === node.id)
      if (index !== -1) {
        this.nodes.splice(index, 1)
        http.put(`talent-nodes/${this.userId}/${node.id}/detach`)
        this.trackEvent(this.analytics.V2.AccountTaggingElementRemovedEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.CAREER, tagName: node.name })
      }
    },

    handleToggleRetired (node, value) {
      http.put(`talent-nodes/${this.userId}/${node.id}/retired`, { status: value })
      this.trackEvent(this.analytics.V2.AccountSectionEditEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.CAREER })
    },

    handleToggleRetiredPending (tag, value) {
      http.put(`talent-nodes/${this.userId}/${tag.id}/retiredPending`, { status: value })
      this.trackEvent(this.analytics.V2.AccountSectionEditEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.CAREER })
    },

    handleDeletePendingTag (tag) {
      const index = this.underReview.findIndex(element => element.id === tag.id)
      if (index !== -1) {
        this.underReview.splice(index, 1)
        http.delete(`talent-nodes/${this.userId}/${tag.id}/delete`)
        this.trackEvent(this.analytics.V2.AccountTaggingElementRemovedEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.CAREER, tagName: tag.name })
      }
    },

    handleSelected (option, nodeId) {
      const index = this.nodes.findIndex(element => element.id === nodeId)
      if (index !== -1) {
        this.nodes.splice(index, 1, option)
        this.handleAttachNode(option.id, option.name)
      }
    },

    handleSearchSelected (option) {
      if (option.custom) {
        return this.handleAddCustomNode(option)
      }

      const optionAncestors = option.ancestors.map(element => element.id)
      let parentNodeIndex = null
      this.nodes.forEach((node, index) => {
        if (!parentNodeIndex) {
          const ancestors = node.ancestors.map(element => element.id)
          ancestors.push(node.id)
          let available = true
          for (let i = 0; i < ancestors.length; i++) {
            if (optionAncestors[i] !== ancestors[i]) {
              available = false
            }
          }
          if (available) {
            parentNodeIndex = index
          }
        }
      })
      if (parentNodeIndex) {
        this.nodes.splice(parentNodeIndex, 1, option)
      } else {
        this.nodes.push(option)
      }
      this.handleAttachNode(option.id, option.name)
    },

    focusSearch () {
      setTimeout(() => {
        document.getElementById('search').focus()
      }, 10)
    }
  },

  computed: {
    ...mapState('user', ['user']),

    userId () {
      return this.$route.params && this.$route.params.id ? this.$route.params.id : this.$user.id
    }
  }
}
</script>

<style lang="scss">
.career {
  .add-button {
    color: var(--brand-primary);
    background: none;
    border: none;
    &--bold {
      text-transform: uppercase;
      letter-spacing: 2px;
      font-weight: 700;
    }
  }
  .fixed {
    position: fixed;
    bottom: 0;
  }
  .relative {
    position: absolute;
    bottom: 0;
  }
  .footer-container {
    width: 100%;
    z-index: 2;
  }
  .footer {
    background-color: white;
    align-items: center;
    padding: 20px;
    @media(min-width: 576px) {
      justify-content: space-between;
    }
    @media(max-width: 576px) {
      justify-content: center;
    }
  }
  .info-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }
  .lead-text {
    font-weight: bold;
    font-size: 14px;
    font-family: Open Sans;
  }
  .career-list-item {
    background-color: #fafafa;
    margin-top: 7.5px;
    margin-bottom: 7.5px;
    &__row {
      padding: 7.5px 15px;
      &--header {
        font-size: 14px;
        font-family: Open Sans,Sans-serif;
        font-weight: 700;
      }
      &--highlight {
        background-color: #f4f4f5;
      }
    }
  }
  .delete-button {
    background-color: #f87171;
    border-radius: 100%;
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      color: white;
      cursor: pointer;
    }
  }
}
</style>
